module.exports = __webpack_public_path__ + "static/media/logo_4x.e1c66826.png";